import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

interface ErrorFallbackProps {
  error?: string;
  resetErrorBoundary?: () => void;
  message?: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ 
  error, 
  resetErrorBoundary,
  message = "Ocorreu um erro ao carregar os dados."
}) => {
  return (
    <Paper 
      elevation={3}
      sx={{ 
        p: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        my: 2
      }}
    >
      <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        {message}
      </Typography>
      {error && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Detalhes: {error}
        </Typography>
      )}
      {resetErrorBoundary && (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={resetErrorBoundary}
          startIcon={<RefreshIcon />}
        >
          Tentar Novamente
        </Button>
      )}
    </Paper>
  );
};

export default ErrorFallback;
